import React, { FC, useCallback, useEffect } from "react";
import {
  ContentWrapper,
  Heading,
} from "containers/RightPanel/RightPanel.styles";
import { ButtonColor, ButtonType, ButtonVariant } from "enums/Button";
import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import { createFieldBlurHandler } from "utils/formValidation";
import { connect } from "react-redux";
import {
  ButtonsWrapper,
  Content,
  FormWrapper,
} from "../../../../components/Addresses/components/AddressForm.styles";
import Button from "../../../../components/Button/Button";
import Input from "../../../../components/Input/Input";
import { updatePrintUserPassword } from "../../../../reduxFolder/reducers/printUsers";
import { closeRightPanel } from "../../../../reduxFolder/reducers/rightPanel";
import { printUserPasswordFormHelper } from "../../helpers/printUserPasswordFormHelper";

interface PrintUserPasswordPanelProps {
  panelData: any;
  isOpen: boolean;
  closeRightPanel: () => void;
  updatePrintUserPassword: (id: number, data: any) => Promise<any>;
}

const PrintUserPasswordPanel: FC<PrintUserPasswordPanelProps> = ({
  panelData,
  isOpen,
  closeRightPanel,
  updatePrintUserPassword,
}) => {
  const { t } = useTranslation("common");
  const printUser = panelData.get("printUser");

  const submitAction = useCallback(
    (data: any) => updatePrintUserPassword(printUser.get("id"), data),
    [printUser, updatePrintUserPassword],
  );

  const formProps = useFormik(
    printUserPasswordFormHelper(t, submitAction, closeRightPanel),
  );

  const {
    values,
    errors,
    touched,
    handleChange,
    handleSubmit,
    handleReset,
    isSubmitting,
  } = formProps;
  const handleBlur = createFieldBlurHandler(formProps);

  useEffect(() => {
    if (!isOpen) handleReset(null);
  }, [isOpen]);

  return (
    <ContentWrapper>
      <Heading>{t("tools.changePassword")}</Heading>
      <FormWrapper onSubmit={handleSubmit}>
        <Content>
          <Input
            placeholder={t("tools.password")}
            name="password"
            type="password"
            value={values.password}
            onChange={handleChange}
            onBlur={handleBlur}
            tooltip={touched.password ? (errors.password as string) : ""}
            invalid={touched.password && !!errors.password}
          />
          <Input
            placeholder={t("tools.passwordConfirmation")}
            name="password_confirmation"
            type="password"
            value={values.password_confirmation}
            onChange={handleChange}
            onBlur={handleBlur}
            tooltip={
              touched.password_confirmation
                ? (errors.password_confirmation as string)
                : ""
            }
            invalid={
              touched.password_confirmation && !!errors.password_confirmation
            }
          />
        </Content>
        <ButtonsWrapper>
          <Button onClick={closeRightPanel}>{t("common.cancel")}</Button>
          <Button
            isLoading={isSubmitting}
            disabled={isSubmitting}
            type={ButtonType.Submit}
            color={ButtonColor.Primary}
            variant={ButtonVariant.Filled}
          >
            {t("tools.changePassword")}
          </Button>
        </ButtonsWrapper>
      </FormWrapper>
    </ContentWrapper>
  );
};

const withConnect = connect(null, {
  updatePrintUserPassword,
  closeRightPanel,
});

export default withConnect(PrintUserPasswordPanel);
